// src/pages/IoTSensing.jsx
import React, { useState } from "react";
import ZoneGrid from "../components/ZoneGrid";
import SensorPanel from "../components/SensorPanel";
import CameraPanel from "../components/CameraPanel";

export default function IoTSensing() {
  const [selectedZone, setSelectedZone] = useState("A");

  return (
    <div className="page-container">
      <div className="flex gap-6">
        <ZoneGrid selectedZone={selectedZone} onSelectZone={setSelectedZone} />
        <div className="flex flex-col gap-6 w-1/2">
          <SensorPanel zone={selectedZone} />
          <CameraPanel zone={selectedZone} />
        </div>
      </div>
    </div>
  );
}
